
import { defineComponent, ref, reactive, watch, nextTick, onMounted, onBeforeUnmount, getCurrentInstance } from 'vue'
import { mapState, useStore } from 'vuex'

import COVERAPP from '@/utils/COVERAPP'

export default defineComponent({
    computed: {
        ...mapState(['activityData'])
    },
    setup (props, context) {
        const _this = getCurrentInstance() as any
        const COVER = _this.proxy.$common
        const $store = useStore()

        onMounted(() => {
            COVER.track('load', '规则页')
            COVER.pageLoaded()
            COVER.onshare($store.state.shareData)
        })    

        return {
            
        }
    }
})
